'use strict';

// export this package's api
module.exports = require('./Animate');


//////////////////
// WEBPACK FOOTER
// ./~/rc-collapse/~/rc-animate/lib/index.js
// module id = 1240
// module chunks = 0